function numericSort(a, b) {
    return Number(a) - Number(b);
}

export default {
    numericSort
};
